import { Alert, Box, Stack, Typography } from '@mui/material'

/**
 * Sampling Data tab placeholder.
 *
 * Access evidence (DocConvert_Quality_overview §6.3):
 *  - Parent subform: `form_frmQualitySamplingSubForm.txt`
 *  - Inner subform: `form_frmQualityQrySampling.txt`
 *  - Query: `QualityQrySampling_all` (view `tlc_factory_view_factory_sampling3`)
 *  - Add forms: `frmQualityQrySamplingAdd`, `frmQualityQrySamplingAddInfo`, `frmQualityQrySamplingAddQC`
 *  - Bulk edit: `frmQualityQrySampling_EditMany*`
 *
 * Toolbar (per §5.2): New / Edit / Copy / Sample Details / Delete / Edit DO / Edit PS Result.
 */
export default function SamplingDataListView() {
  return (
    <Box sx={{ py: 2 }}>
      <Stack spacing={1.5}>
        <Typography variant="subtitle1" fontWeight={700}>
          Sampling Data
        </Typography>
        <Alert severity="info" variant="outlined">
          Tab này chưa được build chi tiết. Theo Access (`frmQualitySamplingSubForm`) đây là
          CRUD list với toolbar: New, Edit, Copy, Sample Details, Delete, Edit DO, Edit PS Result.
        </Alert>
        <Typography variant="body2" color="text.secondary">
          Tham khảo <code>DocConvert_Quality_overview.md §6.3</code> trước khi implement;
          verify schema view <code>tlc_factory_view_factory_sampling3</code> với DB thật.
        </Typography>
      </Stack>
    </Box>
  )
}
